<div class="api-key-configuration">
<button nz-button nzType="link" class="back-button" (click)="back.emit()">
  <span nz-icon nzType="arrow-left"></span>
  Back to API keys
</button>

<div class="api-key-content">
  <div class="api-key-info-card">
    <div class="info-card info-card-name">
      <div>Name</div>
      <input nz-input [(ngModel)]="apiKey.name" name="edit_api_key_name" [disabled]="true" />
    </div>
    <div class="info-card info-card-name">
      <div>Secret</div>
      <input nz-input [ngModel]="apiKey.full_api_key_alias" name="edit_api_key_alias" readonly />
    </div>
    <hr/>
    <div class="info-card info-card-permission">
      <div class="info-card-name">
        <div>Permissions</div>
        <div nz-typography nzType="secondary">Enable only the minimal permissions required for your use case</div>
      </div>
      <nz-select nzMode="multiple" [(ngModel)]="apiKey.permissions" name="edit_permissions" nzPlaceHolder="Select permissions" style="width: 100%">
        <nz-option *ngFor="let permission of permissionOptions" [nzLabel]="permission" [nzValue]="permission"></nz-option>
      </nz-select>
    </div>
  </div>

  <nz-tabset class="tabs" [nzTabBarStyle]="{ paddingLeft: '16px' }">
    <nz-tab nzTitle="Supplier metadata">
      <div class="wrapper">
        <p class="divider">
          <span class="text">Supplier metadata ({{ (apiKey.supplier_metadata ?? []).length }})</span><span class="line"></span>
        </p>
        <supplier-metadata-editor
          [customer]="customer"
          [entries]="apiKey.supplier_metadata ?? []"
          (entriesChange)="onSupplierMetadataChange($event)"
        ></supplier-metadata-editor>
      </div>
    </nz-tab>
    <nz-tab nzTitle="Filter">
      <div class="wrapper">
        <p class="divider">
          <span class="text">Filter ({{ apiKey.filter.length }})</span><span class="line"></span>
        </p>
        <nz-alert
          nzType="warning"
          nzDescription="This API key has access to all vehicles as long as no filter is defined here.
            Once a filter is added, the result is filtered and this API key only has access to vehicles matching the filter."
          nzShowIcon
        ></nz-alert>
        <filter-builder [filter]="apiKey.filter" [persist]="persistFilter" [disabled]="true"></filter-builder>
      </div>
    </nz-tab>
  </nz-tabset>
</div>

<button nz-button nzType="primary" nzDanger class="update-button" [nzLoading]="isSaving" (click)="update()">Update</button>
</div>
